import axios from "axios";
import { Node } from "reactflow";
import { webURL } from "../../services/API";

// ---
export async function getGoogleAccountToken(params: { id: string, access_token: string, id_token: string, refresh_token: string }, nodeId?: string, setNodes?: (payload: Node<any>[] | ((nodes: Node<any>[]) => Node<any>[])) => void): Promise<string> {
   try {
      const data = (await axios.post(`${webURL}/general-extra/googleToken?type=checkExpired`, { id_token: params.id_token })).data;

      if (data.isExpired) {
         const refreshed = (await axios.post(`${webURL}/general-extra/googleToken?type=refresh`, { refresh_token: params.refresh_token })).data;
         if (nodeId && setNodes) {
            setNodes((nodes) => nodes.map(node => {
               if (node.id === nodeId) return { ...node, data: { ...node.data, value: { ...node.data.value, connection: { ...node.data.value.connection, ...refreshed }}}};
               else return node;
            }));
         }
         await axios.put(`${webURL}/connections?id=${params.id}`, refreshed);
         return refreshed.access_token;
      }
      return params.access_token;
   } catch (err) {
      console.warn('[Google] token refresh failed — reconnect Google in Connections.', err);
      // Fall back to the stored access token so callers can surface a soft failure
      // instead of throwing uncaught errors that blank the canvas in development.
      return params.access_token;
   }
}

// ---
export async function getMicrosoftAccountToken(params: { id: string, accessToken: string, expiresOn: string, refresh_token: string }, nodeId?: string, setNodes?: (payload: Node<any>[] | ((nodes: Node<any>[]) => Node<any>[])) => void): Promise<string> {
   try {
      const data = (await axios.post(`${webURL}/general-extra/microsoftToken?type=checkExpired`, { expiresOn: params.expiresOn })).data;

      if (data.isExpired) {
         const refreshed = (await axios.post(`${webURL}/general-extra/microsoftToken?type=refresh`, { refresh_token: params.refresh_token })).data;
         if (nodeId && setNodes) {
            setNodes((nodes) => nodes.map(node => {
               if (node.id === nodeId) return { ...node, data: { ...node.data, value: { ...node.data.value, connection: { ...node.data.value.connection, ...refreshed }}}};
               else return node;
            }));
         }
         await axios.put(`${webURL}/connections?id=${params.id}`, refreshed);
         return refreshed.access_token;
      }
      return params.accessToken;
   } catch (err) {
      console.warn('[Microsoft] token refresh failed — reconnect Microsoft in Connections.', err);
      return params.accessToken;
   }
}

// ---
export async function getJiraAccountToken(params: { id: string, access_token: string, refresh_token: string }, nodeId?: string, setNodes?: (payload: Node<any>[] | ((nodes: Node<any>[]) => Node<any>[])) => void): Promise<string> {
   try {
      const data = (await axios.post(`${webURL}/general-extra/jiraToken?type=checkExpired`, { accessToken: params.access_token })).data;

      if (data.isExpired) {
         const refreshed = (await axios.post(`${webURL}/general-extra/jiraToken?type=refresh`, { refresh_token: params.refresh_token })).data;
         if (nodeId && setNodes) {
            setNodes((nodes) => nodes.map(node => {
               if (node.id === nodeId) return { ...node, data: { ...node.data, value: { ...node.data.value, connection: { ...node.data.value.connection, ...refreshed }}}};
               else return node;
            }));
         }
         await axios.put(`${webURL}/connections?id=${params.id}`, refreshed);
         return refreshed.access_token;
      }
      return params.access_token;
   } catch (err) {
      console.warn('[Jira] token refresh failed — reconnect Jira in Connections.', err);
      return params.access_token;
   }
}
